import { format } from 'date-fns'
import { getMaintenanceStatus } from '../services/ccs-api.service'

/* eslint-disable no-shadow */
const state = () => ({
  activeFrom: '',
  activeTo: '',
  variant: '',
  message: '',
})

const getters = {
  maintenanceActiveFrom: (state) => state.activeFrom,
  maintenanceVariant: (state) => state.variant,
  maintenanceMessage: (state) => state.message,
}

const mutations = {
  setMaintenance(state, maintenance) {
    if (maintenance) {
      console.log('maintenance', maintenance)
      state.activeFrom = format(new Date(maintenance.activeFrom), 'EEEE MMM dd hh:mm a')
      state.activeTo = format(new Date(maintenance.activeTo), 'EEEE MMM dd hh:mm a')
      state.variant = maintenance.variant
      state.message = maintenance.message
    }
  },
  clearMaintenance(state) {
    state.activeFrom = ''
    state.activeTo = ''
  },
}

const actions = {
  async fetchMaintenanceStatus({ commit, rootState }) {
    const data = await getMaintenanceStatus(rootState?.account?.info?.email)

    if (Array.isArray(data) && data.length > 0) {
      commit('setMaintenance', data[0])
    } else {
      commit('clearMaintenance', data)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
